// extracted by mini-css-extract-plugin
export var chip = "_f1-0";
export var filterDropdown = "_f1-5";
export var filterItem = "_f1-6";
export var icon = "_f1-1";
export var removeButton = "_f1-3";
export var removeIcon = "_f1-4";
export var separator = "_f1-2";